import axiosInstance from "api/axiosInstance";
import { providerReportsAction } from "./p-report-slice";
import FileSaver from "file-saver";
import exportAxiosInstance from "api/exportAxiosInstance";
import { withExportColumns } from "utils/reportExportParams";

// Get Provider Transactions
export const getProviderTransactions =
  (
    url,
    pageNumber = 20,
    according = { order: "desc", name: "date" },
    search = null,
    advancedSearch = {}
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setTransactionReport({
        loading: true,
      })
    );
    url = url || "/v1/get-provider-transaction-reports";
    axiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
          advancedSearch: advancedSearch,
        },
      })
      .then((response) => {
        if (response) {
          dispatch(
            providerReportsAction.setTransactionReport({
              loading: false,
              error: null,
              data: response?.data,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setTransactionReport({
            loading: false,
            error: error?.response?.errors,
            data: null,
          })
        );
        console.log(error);
      });
  };

// Get Provider Receipt Reports
export const getProviderReceiptReports =
  (
    url,
    pageNumber = 20,
    according = { order: "desc", name: "date" },
    search = null,
    advancedSearch = {}
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProviderReceiptReport({
        loading: true,
      })
    );
    url = url || "/v1/get-provider-receipt-reports";
    axiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
          advancedSearch: advancedSearch,
        },
      })
      .then((response) => {
        if (response) {
          dispatch(
            providerReportsAction.setProviderReceiptReport({
              loading: false,
              error: null,
              data: response?.data,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProviderReceiptReport({
            loading: false,
            error: error?.response?.errors,
            data: null,
          })
        );
        console.log(error);
      });
  };

// Get Provider Receipt Health Reports
export const getProviderReceiptHealthReports =
  (
    url,
    pageNumber = 20,
    according = { order: "desc", name: "date" },
    search = null,
    advancedSearch = {}
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProviderReceiptHealthReport({
        loading: true,
      })
    );
    url = url || "/v1/get-provider-receipt-health-report";
    axiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
          advancedSearch: advancedSearch,
        },
      })
      .then((response) => {
        if (response) {
          dispatch(
            providerReportsAction.setProviderReceiptHealthReport({
              loading: false,
              error: null,
              data: response?.data,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProviderReceiptHealthReport({
            loading: false,
            error: error?.response?.errors,
            data: null,
          })
        );
        console.log(error);
      });
  };

// Get Provider  Distribution Reports
export const getProviderDistributionReports =
  (
    url,
    pageNumber = 20,
    according = { order: "desc", name: "date" },
    search = null,
    advancedSearch = {}
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProviderDistributionReport({
        loading: true,
      })
    );
    url = url || "/v1/get-provider-distribution-reports";
    axiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
          advancedSearch: advancedSearch,
        },
      })
      .then((response) => {
        if (response) {
          dispatch(
            providerReportsAction.setProviderDistributionReport({
              loading: false,
              error: null,
              data: response?.data,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProviderDistributionReport({
            loading: false,
            error: error?.response?.errors,
            data: null,
          })
        );
        console.log(error);
      });
  };

// Get Provider Province Distribution Reports
export const getProviderProvinceDistributionReports =
  (
    url,
    pageNumber = 20,
    according = { order: "desc", name: "date" },
    search = null,
    advancedSearch = {}
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProviderProvicneDistributionReport({
        loading: true,
      })
    );
    url = url || "/v1/get-provider-province-distributions";
    axiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
          advancedSearch: advancedSearch,
        },
      })
      .then((response) => {
        if (response) {
          dispatch(
            providerReportsAction.setProviderProvicneDistributionReport({
              loading: false,
              error: null,
              data: response?.data,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProviderProvicneDistributionReport({
            loading: false,
            error: error?.response?.errors,
            data: null,
          })
        );
        console.log(error);
      });
  };

// Get Provider Consumption Reports
export const getProviderConsumptionReports =
  (
    url,
    pageNumber = 20,
    according = { order: "desc", name: "date" },
    advancedSearch = {}
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProviderConsumptionReport({
        loading: true,
      })
    );
    advancedSearch.according = according;
    advancedSearch.pageNumber = pageNumber;
    url = url || "/v1/get-provider-consumptions-report";
    axiosInstance
      .get(url, {
        params: advancedSearch,
      })
      .then((response) => {
        if (response) {
          dispatch(
            providerReportsAction.setProviderConsumptionReport({
              loading: false,
              error: null,
              data: response?.data,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProviderConsumptionReport({
            loading: false,
            error: error?.response?.data,
            data: null,
          })
        );
      });
  };

// Get Provider Consumption Reports2
export const getProviderConsumptionReports2 =
  (
    url,
    pageNumber = 20,
    according = { order: "desc", name: "date" },
    advancedSearch = {}
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProviderConsumptionReport({
        loading: true,
      })
    );
    advancedSearch.according = according;
    advancedSearch.pageNumber = pageNumber;
    url = url || "/v1/get-provider-consumptions-report-two";
    axiosInstance
      .get(url, {
        params: advancedSearch,
      })
      .then((response) => {
        if (response) {
          dispatch(
            providerReportsAction.setProviderConsumptionReport({
              loading: false,
              error: null,
              data: response?.data,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProviderConsumptionReport({
            loading: false,
            error: error?.response?.data,
            data: null,
          })
        );
      });
  };

// Get Provider Quantification Reports2
export const getProviderQuantificationReport = (params) => (dispatch) => {
  dispatch(
    providerReportsAction.setProviderQuantificationReport({
      loading: true,
      error: null,
      data: null,
    })
  );
  axiosInstance
    .get(`/v1/get-provider-quantification-report`, {
      params: params ? params : {},
    })
    .then((respnose) => {
      dispatch(
        providerReportsAction.setProviderQuantificationReport({
          loading: false,
          error: null,
          data: respnose?.data,
        })
      );
    })
    .catch((error) => {
      dispatch(
        providerReportsAction.setProviderQuantificationReport({
          loading: false,
          error: error?.response,
          data: null,
        })
      );
      console.log(error);
    });
};

// Get Provider Quantification Reports2 Based Organization
export const getProviderQuantificationReportBasedOrganization =
  (url, params = {}) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProviderQuantificationReport({
        loading: true,
        error: null,
        data: null,
      })
    );

    url = url || `/v1/get-provider-quantification-report-baseOrganization`;
    axiosInstance
      .get(url, {
        params: params,
      })
      .then((respnose) => {
        dispatch(
          providerReportsAction.setProviderQuantificationReport({
            loading: false,
            error: null,
            data: respnose?.data,
          })
        );
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProviderQuantificationReport({
            loading: false,
            error: error?.response,
            data: null,
          })
        );
        console.log(error);
      });
  };

// Export Provider Transactions
export const exportProviderTransactions =
  (
    pageNumber = 10,
    according = { order: "desc", name: "date" },
    search = null,
    advancedSearch = {},
    columns = []
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setTransactionExport({
        loading: true,
        error: null,
        data: null,
      })
    );
    exportAxiosInstance
      .get("/v1/get-provider-transaction-export", {
        params: withExportColumns(
          {
            pageNumber: pageNumber,
            according: according,
            search: search,
            advancedSearch: advancedSearch,
          },
          columns
        ),
      })
      .then((response) => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `Transaction-${Math.random().toString()}.xlsx`
          );
          dispatch(
            providerReportsAction.setTransactionExport({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setTransactionExport({
            loading: false,
            error: error?.response?.errors,
            data: null,
          })
        );
        console.log(error);
      });
  };

// Export Provider Transactions With Project
export const exportProviderTransactionsWithProject =
  (
    pageNumber = 10,
    according = { order: "desc", name: "date" },
    search = null,
    advancedSearch = {},
    columns = []
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setTransactionExport({
        loading: true,
        error: null,
        data: null,
      })
    );
    exportAxiosInstance
      .get("/v1/get-provider-transaction-export-with-project", {
        params: withExportColumns(
          {
            pageNumber: pageNumber,
            according: according,
            search: search,
            advancedSearch: advancedSearch,
          },
          columns
        ),
      })
      .then((response) => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `Transaction-${Math.random().toString()}.xlsx`
          );
          dispatch(
            providerReportsAction.setTransactionExport({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setTransactionExport({
            loading: false,
            error: error?.response?.errors,
            data: null,
          })
        );
        console.log(error);
      });
  };

// Export Provider Receipt Repor
export const exportProviderReceiptReport =
  (
    pageNumber = 10,
    according = { order: "desc", name: "date" },
    search = null,
    advancedSearch = {},
    columns = []
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setReceiptReportExport({
        loading: true,
        error: null,
      })
    );
    exportAxiosInstance
      .get("/v1/get-provider-receipt-export", {
        params: withExportColumns(
          {
            pageNumber: pageNumber,
            according: according,
            search: search,
            advancedSearch: advancedSearch,
          },
          columns
        ),
      })
      .then((response) => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `Receipt-Report-${Math.random().toString()}.xlsx`
          );
          dispatch(
            providerReportsAction.setReceiptReportExport({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setReceiptReportExport({
            loading: false,
            error: error?.response?.errors,
          })
        );
        console.log(error);
      });
  };

// Export Provider Distribution Report
export const exportProviderDistributionReport =
  (
    pageNumber = 10,
    according = { order: "desc", name: "date" },
    search = null,
    advancedSearch = {},
    columns = []
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setDistributionReportExport({
        loading: true,
        error: null,
      })
    );

    exportAxiosInstance
      .get("/v1/get-provider-distribution-export", {
        params: withExportColumns(
          {
            pageNumber: pageNumber,
            according: according,
            search: search,
            advancedSearch: advancedSearch,
          },
          columns
        ),
      })
      .then((response) => {
        if (response) {
          console.log("comming");
          // const url = window.URL.createObjectURL(new Blob([response.data]))
          // const link = document.createElement("a")
          // link.href = url
          // link.setAttribute(
          //   "download",
          //   `Distribution-Report-${Math.random().toString()}.xlsx`
          // )
          // document.body.appendChild(link)
          // link.click()
          // link.remove()
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `Distribution-Report-${Math.random().toString()}.xlsx`
          );
          dispatch(
            providerReportsAction.setDistributionReportExport({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setDistributionReportExport({
            loading: false,
            error: error?.response?.errors,
          })
        );
        console.log(error);
      });
  };

// Export Provider Province Distribution Report
export const exportProviderProvinceDistributionReport =
  (
    pageNumber = 10,
    according = { order: "desc", name: "date" },
    search = null,
    advancedSearch = {},
    columns = []
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProvinceDistributionReportExport({
        loading: true,
        error: null,
      })
    );
    exportAxiosInstance
      .get("/v1/get-provider-province-distributions-export", {
        params: withExportColumns(
          {
            pageNumber: pageNumber,
            according: according,
            search: search,
            advancedSearch: advancedSearch,
          },
          columns
        ),
      })
      .then((response) => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `IP-Distribution-Report-${Math.random().toString()}.xlsx`
          );
          dispatch(
            providerReportsAction.setProvinceDistributionReportExport({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProvinceDistributionReportExport({
            loading: false,
            error: error?.response?.errors,
          })
        );
        console.log(error);
      });
  };

// Export Provider Inventory Report
export const exportProviderInventoryReport =
  (params = {}, columns = []) =>
  (dispatch) => {
  dispatch(
    providerReportsAction.setProviderInventoyExport({
      loading: true,
      error: null,
    })
  );
  exportAxiosInstance
    .get("/v1/get-provider-inventory-export", {
      params: withExportColumns(params ? params : {}, columns),
    })
    .then((response) => {
      if (response) {
        const dataBlob = new Blob([response?.data], {
          type: "application/pdf,",
        });
        FileSaver.saveAs(
          dataBlob,
          `Provider-Inventory-Report-${Math.random().toString()}.xlsx`
        );
        dispatch(
          providerReportsAction.setProviderInventoyExport({
            loading: false,
            error: null,
          })
        );
      }
    })
    .catch((error) => {
      dispatch(
        providerReportsAction.setProviderInventoyExport({
          loading: false,
          error: error?.response?.errors,
        })
      );
      console.log(error);
    });
};

// Export Provider Consumption Report
export const exportProviderConsumptionReports =
  (
    according = { order: "desc", name: "date" },
    advancedSearch = {},
    columns = []
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProviderConsumptionExport({
        loading: true,
        error: null,
      })
    );
    advancedSearch.according = according;
    exportAxiosInstance
      .get("/v1/export-provider-consumptions-report", {
        params: withExportColumns(advancedSearch, columns),
      })
      .then((response) => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `Provider-Consumptions-Report-${Math.random().toString()}.xlsx`
          );
          dispatch(
            providerReportsAction.setProviderConsumptionExport({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProviderConsumptionExport({
            loading: false,
            error: error?.response?.data,
          })
        );
      });
  };

// Export Provider Consumption Report2
export const exportProviderConsumptionReports2 =
  (
    according = { order: "desc", name: "date" },
    advancedSearch = {},
    columns = []
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProviderConsumptionExport({
        loading: true,
        error: null,
      })
    );
    advancedSearch.according = according;
    exportAxiosInstance
      .get("/v1/export-provider-consumptions-report-two", {
        params: withExportColumns(advancedSearch, columns),
      })
      .then((response) => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `Provider-Consumptions-Report-${Math.random().toString()}.xlsx`
          );
          dispatch(
            providerReportsAction.setProviderConsumptionExport({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProviderConsumptionExport({
            loading: false,
            error: error?.response?.data,
          })
        );
      });
  };

// Export Provider Receipt Health Report
export const exportProviderReceiptHealthReport =
  (
    pageNumber = 10,
    according = { order: "desc", name: "date" },
    search = null,
    advancedSearch = {},
    columns = []
  ) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProviderReceiptHealthExport({
        loading: true,
        error: null,
      })
    );
    exportAxiosInstance
      .get("/v1/export-provider-receipt-health-report", {
        params: withExportColumns(
          {
            pageNumber: pageNumber,
            according: according,
            search: search,
            advancedSearch: advancedSearch,
          },
          columns
        ),
      })
      .then((response) => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `Receipt-Health-Report-${Math.random().toString()}.xlsx`
          );
          dispatch(
            providerReportsAction.setProviderReceiptHealthExport({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProviderReceiptHealthExport({
            loading: false,
            error: error?.response?.errors,
          })
        );
        console.log(error);
      });
  };

// Export Provider Quantification Report
export const exportProviderQuantificationReport =
  (params = {}, columns = []) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProviderQuantificationExport({
        loading: true,
        error: null,
      })
    );
    exportAxiosInstance
      .get("/v1/export-provider-quantification-report", {
        params: withExportColumns(params, columns),
      })
      .then((response) => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `Provider-Quantification-report-${Math.random().toString()}.xlsx`
          );
          dispatch(
            providerReportsAction.setProviderQuantificationExport({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProviderQuantificationExport({
            loading: false,
            error: error?.response?.errors,
          })
        );
        console.log(error);
      });
  };

// Export Provider Quantification Report Based Organization
export const exportProviderQuantificationReportBasedOrganization =
  (params = {}, columns = []) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setProviderQuantificationExport({
        loading: true,
        error: null,
      })
    );
    exportAxiosInstance
      .get("/v1/export-provider-quantification-report-baseOrganization", {
        params: withExportColumns(params, columns),
      })
      .then((response) => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `Provider-Quantification-based-organization-report-${Math.random().toString()}.xlsx`
          );
          dispatch(
            providerReportsAction.setProviderQuantificationExport({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setProviderQuantificationExport({
            loading: false,
            error: error?.response?.errors,
          })
        );
        console.log(error);
      });
  };
// Get M&E Report
export const getMEReport =
  (url, pageNumber = 20, search = null, advancedSearch = {}) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setMEReport({
        loading: true,
      })
    );
    url = url || "/v1/get-provider-me-report";
    axiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          search: search,
          ...advancedSearch,
        },
      })
      .then((response) => {
        if (response) {
          dispatch(
            providerReportsAction.setMEReport({
              loading: false,
              error: null,
              data: response?.data,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setMEReport({
            loading: false,
            error: error?.response?.data?.errors,
            data: null,
          })
        );
        console.log(error);
      });
  };

// Export M&E Report
export const exportMEReport =
  (pageNumber = 20, search = null, advancedSearch = {}, columns = []) =>
  (dispatch) => {
    dispatch(
      providerReportsAction.setMEReportExport({
        loading: true,
      })
    );
    exportAxiosInstance
      .get("/v1/export-provider-me-report", {
        params: withExportColumns(
          {
            pageNumber: pageNumber,
            search: search,
            ...advancedSearch,
          },
          columns
        ),
        responseType: "blob",
      })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        FileSaver.saveAs(blob, `ME-Report-${new Date().toISOString()}.xlsx`);
        dispatch(
          providerReportsAction.setMEReportExport({
            loading: false,
            error: null,
          })
        );
      })
      .catch((error) => {
        dispatch(
          providerReportsAction.setMEReportExport({
            loading: false,
            error: error?.response?.data?.errors,
          })
        );
        console.log(error);
      });
  };
